import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../services/api';

const Profile = () => {
  const [me, setMe] = useState(null);
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();

  const loadMe = async () => {
    try {
      const res = await api.get('/me');
      setMe(res.data);
      reset({
        email: res.data.email,
        first_name: res.data.first_name || '',
        last_name: res.data.last_name || '',
        display_name: res.data.display_name || '',
        is_visible: res.data.is_visible === true,
      });
    } catch (e) {
      console.error('Failed to load profile', e);
      toast.error('Failed to load profile');
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadMe(); }, []);

  const onSave = async (data) => {
    try {
      const payload = {
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        display_name: data.display_name,
        is_visible: !!data.is_visible,
      };
      if (data.new_password) {
        payload.new_password = data.new_password;
        payload.old_password = data.old_password || undefined;
      }
      await api.put('/me', payload);
      toast.success('Profile updated');
      // update localStorage copy
      try {
        const u = JSON.parse(localStorage.getItem('authUser') || '{}');
        u.email = data.email;
        u.must_change_password = false;
        localStorage.setItem('authUser', JSON.stringify(u));
      } catch {}
      loadMe();
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Failed to update profile');
    }
  };

  const mustChange = me?.must_change_password === true;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Profile</h1>
        <p className="text-gray-600 mt-2">Update your account details</p>
      </div>

      {mustChange && (
        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
          You must change your password before continuing.
        </div>
      )}

      <div className="card p-6">
        <form onSubmit={handleSubmit(onSave)} className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="label">First Name</label>
            <input className="input" {...register('first_name', { required: 'First name is required' })} />
            {errors.first_name && <p className="text-red-600 text-sm mt-1">{errors.first_name.message}</p>}
          </div>
          <div>
            <label className="label">Last Name</label>
            <input className="input" {...register('last_name', { required: 'Last name is required' })} />
            {errors.last_name && <p className="text-red-600 text-sm mt-1">{errors.last_name.message}</p>}
          </div>
          <div>
            <label className="label">Display Name</label>
            <input className="input" {...register('display_name', { required: 'Display name is required' })} />
            {errors.display_name && <p className="text-red-600 text-sm mt-1">{errors.display_name.message}</p>}
          </div>
          <div className="md:col-span-2">
            <label className="label">Email</label>
            <input type="email" className="input" {...register('email', { required: 'Email is required' })} />
            {errors.email && <p className="text-red-600 text-sm mt-1">{errors.email.message}</p>}
          </div>
          <div className="md:col-span-3">
            <label className="inline-flex items-center space-x-2">
              <input type="checkbox" className="h-4 w-4" {...register('is_visible')} />
              <span className="text-sm text-gray-700">Make my profile searchable/visible</span>
            </label>
          </div>

          <div>
            <label className="label">Old Password</label>
            <input type="password" className="input" placeholder="(required unless forced change)" {...register('old_password')} />
          </div>
          <div>
            <label className="label">New Password</label>
            <input type="password" className="input" placeholder="New password" {...register('new_password', mustChange ? { required: 'New password is required' } : {})} />
            {errors.new_password && <p className="text-red-600 text-sm mt-1">{errors.new_password.message}</p>}
          </div>

          <div className="md:col-span-2">
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Saving…' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;